import $axios from '../../settings/axios.js';
import localizationTexts from '@/localization/texts.json';
import optionsHelper from '../../helpers/optionsHelper';

const state = {
  user: {
    tokenTimeout: null,
    loading: false,
    token: '',
    tokenpolicy: {},
    tokenexpired: false,
    tokenexpirationtimer: 0,
    guid: '',
    selectedRooftopid: '',
    rooftopids: [],
    step: 0,
    registrationplate: '',
    registrationplateError: false,
    car: {},
    kilometers: '',
    department: {},
    services: [],
    selectedservices: [],
    carbrands: [],
    servicesTime: {
      hours: 0,
      minutes: 0
    },
    datetime: {
      option: '',
      date: '',
      arrival: '',
      pickup: '',
      waiting: false,
      rental: false
    },
    info: {
      firstname: '',
      lastname: '',
      address: '',
      address2: '',
      zipcode: '',
      city: '',
      state: '',
      region: '',
      country: '',
      email: '',
      phone: '',
      accepted: false
    },
    config: {
      language: 'en',
      parameters: [],
      container: '',
      host: '',
      categorized: false,
      grouped: false
    },
    lists: {
      selectedIndexMake: 0,
      selectedIndexModel: 0,
      selectedIndexVariant: 0,
      carMakes: [],
      carModels: [],
      carVariants: [],
      departments: {
        initial: [],
        eligable: [],
        output: []
      },
      services: [],
      dates: [],
      rentaldates: [],
      optiondto: [],
      optionsDatesMappings: [],
      timesArrival: [],
      timesArrivalManual: [],
      timesArrivalManualWaiting: [],
      timesArrivalManualRental: [],
      timesArrivalManualRentLog: [],
      timesPickup: []
    },
    errors: {
      app: false,
      registration: '',
      departments: '',
      services: '',
      date: '',
      time: '',
      customer: '',
      options: ''
    },
    validation: false,
    specialProperties: {
      forwarding: {
        // BWSOL2-500 til Kia Import Danmark A/S
        endpoint: '',
        marketingConsent: false,
        marketingConsentText: ''
      },
      timesandoptionsdescriptions: [], //BWSOL2-495 til Andersen & Martini A/S
      pickuptimeOverwrite: '' //BWSOL2-508 til Andersen & Martini A/S
    },
    dummy: '',
    registrationplateerrormessagekey: ''
  }
};

const getters = {
  user: state => state.user
};
const actions = {
  initLoading({ commit }, payload) {
    commit('SET_LOADING', payload);
  },
  initStep({ commit }, payload) {
    commit('SET_STEP', payload);
  },
  initGuid({ commit }, payload) {
    commit('SET_GUID', payload);
  },

  async handleOptionsDatesMappings({ state }) {
    /**
     * @type string[]
     */
    const dates = [...state.user.lists.dates];

    if (dates && dates.length > 0) {
      const servicesTimeHoursToMinutes = state.user.servicesTime.hours * 60;
      const servicesTime = servicesTimeHoursToMinutes + state.user.servicesTime.minutes;
      let params = {
        token: state.user.token,
        traceid: state.user.guid,
        rooftopid: state.user.selectedRooftopid,
        culture: state.user.config.parameters.parameters.culture,
        makecode: state.user.car.makecode,
        modelcode: state.user.car.modelcode,
        variantcode: state.user.car.variantcode,
        services: state.user.selectedservices,
        registrationplate: state.user.registrationplate,
        totalserviceduration: servicesTime,
        times: [],
        disablewaitingoption: state.user.config.parameters.parameters.disablewaitingoption
      };

      if (state.user.config.parameters.parameters.times) {
        params.times.push({
          id: 1000,
          list: JSON.parse(state.user.config.parameters.parameters.times.replace(/'/g, '"')),
          replace: state.user.config.parameters.parameters.timesreplace ? state.user.config.parameters.parameters.timesreplace : false
        });
      }
      if (state.user.config.parameters.parameters.timesrental) {
        params.times.push({
          id: 1001,
          list: JSON.parse(state.user.config.parameters.parameters.timesrental.replace(/'/g, '"')),
          replace: state.user.config.parameters.parameters.timesreplacerental ? state.user.config.parameters.parameters.timesreplacerental : false
        });
      }
      if (state.user.config.parameters.parameters.timeswaiting) {
        params.times.push({
          id: 1002,
          list: JSON.parse(state.user.config.parameters.parameters.timeswaiting.replace(/'/g, '"')),
          replace: state.user.config.parameters.parameters.timesreplacewaiting ? state.user.config.parameters.parameters.timesreplacewaiting : false
        });
      }
      if (state.user.config.parameters.parameters.timesrentlogrental) {
        params.times.push({
          id: 1100,
          list: JSON.parse(state.user.config.parameters.parameters.timesrentlogrental.replace(/'/g, '"')),
          replace: state.user.config.parameters.parameters.timesreplacerentlogrental
            ? state.user.config.parameters.parameters.timesreplacerentlogrental
            : false
        });
      }
    }
  },
  optionsDatesMappingsClear: ({ commit }) => commit('CLEAR_OPTIONSFORDATEMAPPING'),
  setOptionsDatesMappings: ({ commit }, datesMapping) => {
    const optiondtoList = optionsHelper.handleTimesAndOptions(state, datesMapping.options);
    commit('SET_DATEDATE', datesMapping.date);
    commit('SET_LISTOPTIONS', optiondtoList);
  },
  async initToken({ commit }, payload) {
    let data = {
      response: '',
      rooftopid: payload.params.rooftopid
    };

    return await $axios.get(payload.endpoint, { params: payload.params }).then(
      response => {
        data.response = response.data;
        commit('SET_TOKEN', data);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_TOKEN',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataGeneral', errorPayload);
      }
    );
  },
  initCarBrands({ commit }, payload) {
    commit('SET_CARBRANDS', payload);
  },
  initSelectedRooftopid({ commit }, payload) {
    commit('SET_SELECTEDROOFTOPID', payload);
  },
  initRooftopIds({ commit }, payload) {
    commit('SET_ROOFTOPIDS', payload);
  },
  initAppointment({ commit }, payload) {
    commit('SET_APPOINTMENT', payload);
  },
  initRegistrationPlate({ commit }, payload) {
    commit('SET_REGISTRATIONPLATE', payload);
  },
  async initCar({ commit }, payload) {
    return await $axios.post(payload.endpoint, payload.params).then(
      response => {
        commit('SET_REGISTRATIONPLATEERRORMESSAGE', '');
        commit('SET_CAR', response.data);
      },
      error => {
        if (error.toString().indexOf('404') > -1) {
          const errorPayload = {
            modal: false,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'SET_CAR',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setInputRegistrationplate', errorPayload);

          // set error text for unknown registration plate
          commit('SET_REGISTRATIONPLATEERRORMESSAGE', error.response.data.localizationkey);

          let response = {
            type: '',
            estvehicleagemonths: null,
            estregdate: '0001-01-01T00:00:00+00:00',
            estodometer: null,
            transmissioncode: null,
            fuelcode: '',
            enginesize: '',
            registrationplate: state.user.registrationplate,
            makecode: null,
            modelcode: null,
            variantcode: null,
            varianttext: '',
            modeltext: '',
            maketext: ''
          };
          commit('SET_CAR', response);

          let data = [];
          for (let rooftopid of state.user.rooftopids) {
            const payloadMakes = {
              endpoint: state.user.config.parameters.api + '/maintenance/GetMakesData',
              params: {
                token: state.user.token,
                culture: state.user.config.parameters.parameters.culture,
                rooftopid: rooftopid,
                test: state.user.config.parameters.parameters.test,
                traceid: state.user.guid
              }
            };
            $axios.post(payloadMakes.endpoint, payloadMakes.params).then(
              response => {
                response.data.makes.forEach(item => {
                  let element = {
                    text: item.makename,
                    value: item.makecode
                  };
                  if (data.length == 0 || data.findIndex(candidate => candidate.text === element.text && candidate.value === element.value) < 0) {
                    data.push(element);
                  }
                });
              },
              error => {
                const errorPayload = {
                  modal: true,
                  send: false,
                  traceid: state.user.guid,
                  error: {
                    message: 'GET_CAR_MAKES',
                    jsondata: JSON.stringify(error)
                  }
                };
                this.dispatch('errors/setDataCar', errorPayload);
              }
            );
            commit('SET_CARLISTMAKESMANUAL', data);
          }
        } else {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_CAR',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataCar', errorPayload);
        }
      }
    );
  },
  errorDate({ commit }) {
    commit('SET_ERRORSDATE');
  },
  errorOptions({ commit }) {
    commit('SET_ERRORSOPTIONS');
  },
  initCarDetailMakeManual({ commit }, payload) {
    commit('SET_CARDETAILMAKEMANUAL', payload);
  },
  initCarDetailModelManual({ commit }, payload) {
    commit('SET_CARDETAILMODELMANUAL', payload);
  },
  initCarDetailVariantManual({ commit }, payload) {
    commit('SET_CARDETAILVARIANTMANUAL', payload);
  },
  async initListCarMakesManual({ commit }, payload) {
    let data = [];
    // webservice call start
    return await $axios.post(payload.endpoint, payload.params).then(response => {
      response.data.makes.forEach(
        item => {
          data.push({
            text: item.makename,
            value: item.makecode
          });
        },
        error => {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_CAR_MAKES',
              jsondata: error
            }
          };
          this.dispatch('errors/setDataCar', errorPayload);
        }
      );

      commit('SET_CARLISTMAKESMANUAL', data);
    });
  },
  async initListCarModelsManual({ commit }, payload) {
    let data = [];
    if (payload.params.test) {
      data.push({
        text: 'Alle',
        value: 'ZZ'
      });
      commit('SET_CARLISTMODELSSMANUAL', data);
    } else {
      return await $axios.post(payload.endpoint, payload.params).then(response => {
        response.data.models.forEach(
          item => {
            data.push({
              text: item.modelname,
              value: item.modelcode
            });
          },
          error => {
            const errorPayload = {
              modal: true,
              send: false,
              traceid: state.user.guid,
              error: {
                message: 'GET_CAR_MODELS',
                jsondata: error
              }
            };
            this.dispatch('errors/setDataCar', errorPayload);
          }
        );
        commit('SET_CARLISTMODELSSMANUAL', data);
      });
    }
  },
  async initListCarVariantsManual({ commit }, payload) {
    let data = [];
    if (payload.params.test) {
      data.push({
        text: 'Alle',
        value: 'ZZ'
      });
      commit('SET_CARLISTVARIANTSMANUAL', data);
    } else {
      // webservice call start
      return await $axios.post(payload.endpoint, payload.params).then(response => {
        response.data.variants.forEach(
          item => {
            data.push({
              text: item.variantname,
              value: item.variantcode
            });
          },
          error => {
            const errorPayload = {
              modal: true,
              send: false,
              traceid: state.user.guid,
              error: {
                message: 'GET_CAR_VARIANTS',
                jsondata: error
              }
            };
            this.dispatch('errors/setDataCar', errorPayload);
          }
        );
        commit('SET_CARLISTVARIANTSMANUAL', data);
      });
    }
  },
  initListCarMakesManualReset({ commit }) {
    commit('SET_CARLISTMAKESMANUAL', []);
  },
  initListCarModelsManualReset({ commit }) {
    commit('SET_CARLISTMODELSSMANUAL', []);
  },
  initListCarVariantsManualReset({ commit }) {
    commit('SET_CARLISTVARIANTSMANUAL', []);
  },
  async initCarDetailMake({ commit }, payload) {
    return await $axios
      .post(payload.endpoint, payload.params)
      .then(
        response => {
          if (response.status === 200 && response.data) {
            let data = {
              response: response.data,
              rooftopid: payload.params.rooftopid
            };
            commit('SET_CARDETAILMAKE', data);
          } else if (response.status === 418) {
            let data = {
              response: { makecode: '' },
              rooftopid: payload.params.rooftopid
            };
            commit('SET_CARDETAILMAKE', data);
          } else if (response.status === 500) {
            const errorPayload = {
              modal: true,
              send: false,
              traceid: state.user.guid,
              error: {
                message: 'GET_CAR_DETAIL_MAKE',
                jsondata: JSON.stringify(response)
              }
            };
            this.dispatch('errors/setDataCar', errorPayload);
          } else {
            const errorPayload = {
              modal: true,
              send: false,
              traceid: state.user.guid,
              error: {
                message: 'GET_CAR_DETAIL_MAKE',
                jsondata: JSON.stringify(response)
              }
            };
            this.dispatch('errors/setDataCar', errorPayload);
          }
        },
        error => {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_CAR_DETAIL_MAKE',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataCar', errorPayload);
        }
      )
      .catch(response => {
        if (response.toString().indexOf('status code 418') > -1) {
          let data = {
            response: { makecode: '' },
            rooftopid: payload.params.rooftopid
          };
          commit('SET_CARDETAILMAKE', data);
        } else if (response.toString().indexOf('status code 500') > -1) {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_CAR_DETAIL_MAKE',
              jsondata: JSON.stringify(response)
            }
          };
          this.dispatch('errors/setDataCar', errorPayload);
        }
      });
  },
  async initCarDetailModel({ commit }, payload) {
    return await $axios.post(payload.endpoint, payload.params).then(
      response => {
        if (response.status === 200 && response.data) {
          let data = {
            response: response.data,
            rooftopid: payload.params.rooftopid
          };
          commit('SET_CARDETAILMODEL', data);
        } else if (response.status === 418) {
          let data = {
            response: { modelcode: '' },
            rooftopid: payload.params.rooftopid
          };
          commit('SET_CARDETAILMODEL', data);
        }
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_CAR_DETAIL_MODEL',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataCar', errorPayload);
      }
    );
  },
  async initCarDetailVariant({ commit }, payload) {
    return await $axios.post(payload.endpoint, payload.params).then(
      response => {
        if (response.status === 200 && response.data) {
          let data = {
            response: response.data,
            rooftopid: payload.params.rooftopid
          };
          commit('SET_CARDETAILVARIANT', data);
        } else if (response.status === 418) {
          let data = {
            response: { variantcode: '' },
            rooftopid: payload.params.rooftopid
          };
          commit('SET_CARDETAILVARIANT', data);
        }
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_CAR_DETAIL_MODEL',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataCar', errorPayload);
      }
    );
  },
  initCarReset({ commit }) {
    commit('SET_CAR', {});
  },
  initKilometers({ commit }, payload) {
    commit('SET_KILOMETERS', payload);
  },
  initDepartment({ commit }, payload) {
    if (payload.change) {
      let departments = state.user.lists.departments.output;
      this.dispatch('user/initSelectedRooftopid', payload.response.rooftopid);
      state.user.services = [];
      state.user.selectedservices = [];
      let filtered = departments.filter(function (item) {
        return item.rooftopid === state.user.selectedRooftopid;
      });
      if (filtered.length > 0) {
        state.user.lists.services = filtered[0].services;
        state.user.car.makecode = filtered[0].car.makecode;
        state.user.car.modelcode = filtered[0].car.modelcode;
        state.user.car.variantcode = filtered[0].car.variantcode;
      }
    }
    commit('SET_DEPARTMENT', payload.response);
  },
  initServices({ commit }, payload) {
    let services = state.user.services;

    if (state.user.services.some(e => e.jobcode === payload.jobcode)) {
      let filtered = services.filter(function (item) {
        return item.jobcode != payload.jobcode;
      });
      services = filtered;
    } else {
      services.push(payload);
    }
    commit('SET_SERVICE', services);
  },
  initServicesTime({ commit }, payload) {
    commit('SET_SERVICE_TIME', payload);
  },
  initServicesBulk({ commit }, payload) {
    commit('SET_SERVICE', payload);
  },
  initUserNameFirst({ commit }, payload) {
    commit('SET_USERNAMEFIRST', payload);
  },
  initUserNameLast({ commit }, payload) {
    commit('SET_USERNAMELAST', payload);
  },
  initUserAddress({ commit }, payload) {
    commit('SET_USERADDRESS', payload);
  },
  initUserAddress2({ commit }, payload) {
    commit('SET_USERADDRESS2', payload);
  },
  initUserZipcode({ commit }, payload) {
    commit('SET_USERZIPCODE', payload);
  },
  initUserCity({ commit }, payload) {
    commit('SET_USERCITY', payload);
  },
  initUserRegion({ commit }, payload) {
    commit('SET_USERREGION', payload);
  },
  initUserState({ commit }, payload) {
    commit('SET_USERSTATE', payload);
  },
  initUserCountry({ commit }, payload) {
    commit('SET_USERCOUNTRY', payload);
  },
  initUserEmail({ commit }, payload) {
    commit('SET_USEREMAIL', payload);
  },
  initUserNumberPhone({ commit }, payload) {
    commit('SET_USERNUMBERPHONE', payload);
  },
  initUserAccepted({ commit }, payload) {
    commit('SET_USERACCEPTED', payload);
  },
  initDateOption({ commit }, payload) {
    commit('SET_DATEOPTION', payload);
  },
  initDateDate({ commit }, payload) {
    commit('SET_DATEDATE', payload);
  },
  setDateTimeArrival({ commit }, payload) {
    commit('SET_DATETIMEARRIVAL', payload);
  },
  setDateTimePickup({ commit }, payload) {
    commit('SET_DATETIMEPICKUP', payload);
  },
  initConfigLanguage({ commit }, payload) {
    commit('SET_CONFIGLANGUAGE', payload);
  },
  initConfigContainer({ commit }, payload) {
    commit('SET_CONFIGCONTAINER', payload);
  },
  initConfigHost({ commit }, payload) {
    commit('SET_CONFIGHOST', payload);
  },
  initConfigParameters({ commit }, payload) {
    commit('SET_CONFIGPARAMETERS', payload);
  },
  initCheckToken({ commit }) {
    if (state.user.tokenpolicy.tokenexpiration === 1) {
      clearTimeout(state.user.tokenTimeout);
      commit('SET_TOKENTIMEOUT', state.user.tokenexpirationtimer);
    } else if (state.user.tokenpolicy.tokenexpiration === 2 && state.user.tokenTimeout === null) {
      commit('SET_TOKENTIMEOUT', state.user.tokenexpirationtimer);
    }
  },
  async initTokenPolicy({ commit }, payload) {
    return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
      response => {
        commit('SET_TOKENPOLICY', response.data);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'SET_TOKEN_POLICY',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataTokenPolicy', errorPayload);
      }
    );
  },
  async initGetCulture({ commit }, payload) {
    return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
      response => {
        commit('SET_CONFIGLANPROP', response.data);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_CULTURE',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataServices', errorPayload);
      }
    );
  },
  async initListServices({ commit }, payload) {
    return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
      response => {
        response.data.services.forEach(item => {
          if (item.jobdescription !== null) {
            item.jobdescription = item.jobdescription.replace(
              'genericServiceJobDescription',
              localizationTexts[state.user.config.language].pageServices.genericServiceJobDescription
            );
          }
          if (item.specialplaceholdertextfortextarea !== null) {
            item.specialplaceholdertextfortextarea = item.specialplaceholdertextfortextarea.replace(
              'genericServicePlaceholderText',
              localizationTexts[state.user.config.language].pageServices.genericServicePlaceholderText
            );
          }
        });

        let data = {
          response: response.data.services,
          rooftopid: payload.params.rooftopid
        };
        commit('SET_LISTSERVICES', data);
        this.dispatch('user/initLoading', false);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_SERVICES',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataServices', errorPayload);
      }
    );
  },
  initListDepartments({ commit }) {
    let payload = [];
    state.user.lists.departments.initial.forEach(current => {
      let filtered = state.user.lists.departments.eligable.filter(function (item) {
        return item.rooftopid === current.rooftopid;
      });
      if (filtered.length > 0) {
        payload.push(filtered[0]);
      }
    });
    commit('SET_LISTDEPARTMENTS', payload);
  },
  async initListSpecificDepartments({ commit }, payload) {
    if (payload.params.test) {
      let response = [
        {
          widgetid: '3c4328af-f9a7-4143-8acc-b88c8db111e7',
          departmentid: '242',
          rooftopid: 'DK31082020',
          name: 'Auto IT 1',
          contactemail: 'no-reply@autoit.dk',
          address: 'Skagensgade 1',
          zipcode: '2630',
          city: 'Taastrup',
          defaultconfiguration: null,
          url: 'http://autoit.dk',
          created: '2020-03-30T20:53:58.6696524',
          modified: null
        },
        {
          widgetid: '48ff6098-7515-4fe2-ae2a-af25a8b19d75',
          departmentid: '5023',
          rooftopid: 'DK31084020',
          name: 'Auto IT 2',
          contactemail: 'no-reply@autoit.dk',
          address: 'Skagensgade 2',
          zipcode: '2630',
          city: 'Taastrup',
          defaultconfiguration: null,
          url: 'http://autoit.dk',
          created: '2020-03-30T20:53:58.6696144',
          modified: null
        },
        {
          widgetid: '5079b40d-5ae6-4273-bf88-e9fcfd4cb11c',
          departmentid: '854',
          rooftopid: 'DK31086020',
          name: 'Auto IT 3',
          contactemail: 'no-reply@autoit.dk',
          address: 'Skagensgade 3',
          zipcode: '2630',
          city: 'Taastrup',
          defaultconfiguration: null,
          url: 'http://autoit.dk',
          created: '2020-03-30T20:53:58.6696549',
          modified: null
        }
      ];
      commit('SET_LISTSPECIFICDEPARTMENTS', response);
    } else {
      return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
        response => {
          commit('SET_LISTSPECIFICDEPARTMENTS', response.data);
        },
        error => {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_DEPARTMENTS_INITIAL',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataDepartments', errorPayload);
        }
      );
    }
  },
  async initListEligableDepartments({ commit }, payload) {
    var data = {
      endpoint: 'registration',
      data: '',
      error: ''
    };
    commit('SET_ERRORS', data);
    commit('SET_PLATEERROR', false);

    if (payload.params.test) {
      let response = [
        {
          widgetid: '3c4328af-f9a7-4143-8acc-b88c8db111e7',
          departmentid: '242',
          rooftopid: 'DK31082020',
          name: 'Auto IT 1',
          contactemail: 'no-reply@autoit.dk',
          address: 'Skagensgade 1',
          zipcode: '2630',
          city: 'Taastrup',
          defaultconfiguration: null,
          url: 'http://autoit.dk',
          created: '2020-03-30T20:53:58.6696524',
          modified: null
        },
        {
          widgetid: '5079b40d-5ae6-4273-bf88-e9fcfd4cb11c',
          departmentid: '854',
          rooftopid: 'DK31086020',
          name: 'Auto IT 3',
          contactemail: 'no-reply@autoit.dk',
          address: 'Skagensgade 3',
          zipcode: '2630',
          city: 'Taastrup',
          defaultconfiguration: null,
          url: 'http://autoit.dk',
          created: '2020-03-30T20:53:58.6696549',
          modified: null
        }
      ];
      commit('SET_LISTELIGABLEDEPARTMENTS', response);
    } else {
      return await $axios.post(payload.endpoint, payload.params).then(
        response => {
          commit('SET_LISTELIGABLEDEPARTMENTS', response.data);
          if (response.data.length < 1) {
            let data = {
              endpoint: 'registration',
              data: localizationTexts[state.user.config.language].validation.specific.noEligableDepartments,
              error: localizationTexts[state.user.config.language].validation.specific.noEligableDepartments
            };
            commit('SET_ERRORS', data);
            commit('SET_PLATEERROR', true);
          }
        },
        error => {
          const errorPayload = {
            modal: false,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_DEPARTMENTS_ELIGIBLE',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataDepartments', errorPayload);
          commit('SET_PLATEERROR', true);
          const error404 = localizationTexts[state.user.config.language].validation.specific.noEligableDepartments;
          const error500 = localizationTexts[state.user.config.language].errors.UnknownErrorOccured.title;
          data = {
            endpoint: 'registration',
            data: error.toString().indexOf('404') ? error404 : error500,
            error: error
          };
          commit('SET_ERRORS', data);
        }
      );
    }
  },
  async initListDates({ commit }, payload) {
    if (payload.params.test) {
      let response = [];
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      let date = currentDate.getDate();
      for (let d = 0; d < state.user.config.parameters.parameters.calendarinterval * 30; d++) {
        let newDate = new Date(year, month, date);
        newDate.setDate(newDate.getDate() + d);
        if (d % 10 === 0 || d % 10 === 1 || d % 10 === 2 || d % 10 === 5 || d % 10 === 6 || d % 10 === 8 || d % 10 === 9) {
          response.push(
            newDate
              .toISOString()
              .slice(0, 10)
              .toString()
          );
        }
      }
      let array = [];
      response.forEach(item => {
        array.push(item);
      });
      commit('SET_LISTDATES', array);
    } else {
      return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
        response => {
          let array = [];
          response.data.forEach(item => {
            array.push(
              new Date(item.date + 'Z')
                .toISOString()
                .slice(0, 10)
                .toString()
            );
          });
          commit('SET_LISTDATES', array);
        },
        error => {
          const errorPayload = {
            modal: true,
            send: false,
            traceid: state.user.guid,
            error: {
              message: 'GET_DATES',
              jsondata: JSON.stringify(error)
            }
          };
          this.dispatch('errors/setDataDates', errorPayload);
        }
      );
    }
  },
  async initListRentalDates({ commit }, payload) {
    commit('SET_LISTRENTALDATES', payload);
  },
  async initListDatesClear({ commit }) {
    commit('SET_LISTDATESCLEAR');
  },
  initListSelectedIndexMake({ commit }, payload) {
    commit('SET_LISTSELECTEDINDEXMAKE', payload);
  },
  initListSelectedIndexModel({ commit }, payload) {
    commit('SET_LISTSELECTEDINDEXMODEL', payload);
  },
  initListSelectedIndexVariant({ commit }, payload) {
    commit('SET_LISTSELECTEDINDEXVARIANT', payload);
  },
  async initListOptions({ commit }, payload) {
    return await $axios.post(payload.endpoint, JSON.stringify(payload.params)).then(
      response => {
        if (response.data.optionsfordatesdto[0].options) {
          const optiondtoList = optionsHelper.handleTimesAndOptions(state, response.data.optionsfordatesdto[0].options);
          commit('SET_LISTOPTIONS', optiondtoList);
        }
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: state.user.guid,
          error: {
            message: 'GET_OPTIONS',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataOptions', errorPayload);
      }
    );
  },
  initErrorsApp({ commit }, payload) {
    commit('SET_ERRORSAPP', payload);
  },
  initErrors({ commit }, payload) {
    let data = {
      endpoint: payload.endpoint,
      data: payload.data,
      error: payload.error
    };
    commit('SET_ERRORS', data);
  },
  initValidation({ commit }, payload) {
    commit('SET_VALIDATION', payload);
  },
  initPickuptimeOverwrite({ commit }, payload) {
    //BWSOL2-508 til Andersen & Martini A/S
    commit('SET_PICKUPTIMEOVERWRITE', payload);
  },
  initForwardingEndpoint({ commit }, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    commit('SET_FORWARDINGENDPOINT', payload);
  },
  initMarketingConsent({ commit }, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    commit('SET_MARKETINGCONSENT', payload);
  },
  initMarketingConsentText({ commit }, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    commit('SET_MARKETINGCONSENTTEXT', payload);
  },
  sendForwardingBookingInfo({ commit, state }, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    if (state.user.specialProperties.forwarding != '' && payload) {
      $axios
        .post(state.user.config.parameters.api + '/maintenance/ForwardingBookingInfo', {
          encryptData: payload,
          rooftopId: state.user.department.rooftopid,
          traceid: state.user.guid
        })
        .then(
          response => {
            this.dispatch('errors/resetErrors');
            commit('SEND_FORWARDINGBOOKINGINFO', response);
          },
          error => {
            const errorPayload = {
              modal: false,
              send: false,
              traceid: state.user.guid,
              error: {
                message: 'SEND_FORWARDINGBOOKING',
                jsondata: JSON.stringify(error)
              }
            };
            this.dispatch('errors/setDataOther', errorPayload);
          }
        );
    }
  }
};
const mutations = {
  SET_LOADING(state, payload) {
    state.user.loading = payload;
  },
  SET_STEP(state, payload) {
    state.user.step = payload;
  },
  SET_GUID(state, payload) {
    state.user.guid = payload;
  },
  SET_TOKEN(state, payload) {
    if (payload.rooftopid !== undefined) {
      const departments = state.user.lists.departments.output;
      for (let i = 0; i < departments.length; i++) {
        if (departments[i].rooftopid === payload.rooftopid) {
          departments[i].token = payload.response;
        }
      }
    }
    state.user.token = payload.response;
  },
  ADD_OPTIONSFORDATEMAPPING(state, optionsDatesMappings) {
    let modOptionsDatesMappings = optionsDatesMappings;
    modOptionsDatesMappings.forEach(optionsDate => {
      return state.user.lists.optionsDatesMappings.find(x => x.date == optionsDate.date);
    });
    state.user.lists.optionsDatesMappings = modOptionsDatesMappings;
  },
  CLEAR_OPTIONSFORDATEMAPPING: state => (state.user.lists.optionsDatesMappings = []),
  SET_SELECTEDROOFTOPID(state, payload) {
    state.user.selectedRooftopid = payload;
  },
  SET_CARBRANDS(state, payload) {
    state.user.carbrands = payload;
  },
  SET_ROOFTOPIDS(state, payload) {
    state.user.rooftopids = payload;
  },
  SET_REGISTRATIONPLATE(state, payload) {
    state.user.registrationplate = payload;
  },
  SET_CAR(state, payload) {
    state.user.car = payload;
    state.user.car.estodometer = state.user.kilometers.toString();
  },
  SET_CARDETAILMAKEMANUAL(state, payload) {
    state.user.car.maketext = payload;
  },
  SET_CARDETAILMODELMANUAL(state, payload) {
    state.user.car.modeltext = payload;
  },
  SET_CARDETAILVARIANTMANUAL(state, payload) {
    state.user.car.varianttext = payload;
  },
  SET_CARLISTMAKESMANUAL(state, payload) {
    state.user.lists.carMakes = payload;
  },
  SET_PLATEERROR(state, payload) {
    state.user.registrationplateError = payload;
  },
  SET_CARLISTMODELSSMANUAL(state, payload) {
    state.user.lists.carModels = payload;
  },
  SET_CARLISTVARIANTSMANUAL(state, payload) {
    let modPayload = payload;
    modPayload.sort((a, b) => a.text.localeCompare(b.text));
    state.user.lists.carVariants = modPayload;
  },
  SET_CARDETAILMAKE(state, payload) {
    if (payload.rooftopid !== undefined) {
      const departments = state.user.lists.departments.output;
      for (let i = 0; i < departments.length; i++) {
        if (departments[i].rooftopid === payload.rooftopid) {
          departments[i].car.makecode = payload.response.makecode;
        }
      }
    }
    state.user.car.makecode = payload.response.makecode;
  },
  SET_CARDETAILMODEL(state, payload) {
    if (payload.rooftopid !== undefined) {
      const departments = state.user.lists.departments.output;
      for (let i = 0; i < departments.length; i++) {
        if (departments[i].rooftopid === payload.rooftopid) {
          departments[i].car.modelcode = payload.response.modelcode;
        }
      }
    }

    state.user.car.modelcode = payload.response.modelcode;
  },
  SET_CARDETAILVARIANT(state, payload) {
    if (payload.rooftopid !== undefined) {
      const departments = state.user.lists.departments.output;
      for (let i = 0; i < departments.length; i++) {
        if (departments[i].rooftopid === payload.rooftopid) {
          departments[i].car.variantcode = payload.response.variantcode;
        }
      }
    }

    state.user.car.variantcode = payload.response.variantcode;
  },
  SET_KILOMETERS(state, payload) {
    state.user.kilometers = payload;
    if (state.user.car.estodometer !== null && state.user.car.estodometer !== undefined) {
      state.user.car.estodometer = payload.toString();
    }
  },
  SET_DEPARTMENT(state, payload) {
    if (payload?.services && payload.services?.length < 1) {
      state.user.department = [];
      return;
    }
    state.user.department = payload;
  },
  SET_SERVICE(state, payload) {
    state.user.services = payload;
    state.user.selectedservices = [];
    state.user.services.forEach(item => {
      state.user.selectedservices.push(item);
    });
  },
  SET_SERVICE_TIME(state, payload) {
    state.user.servicesTime.hours = payload.hours;
    state.user.servicesTime.minutes = payload.minutes;
  },
  SET_USERNAMEFIRST(state, payload) {
    state.user.info.firstname = payload;
  },
  SET_USERNAMELAST(state, payload) {
    state.user.info.lastname = payload;
  },
  SET_USERADDRESS(state, payload) {
    state.user.info.address = payload;
  },
  SET_USERADDRESS2(state, payload) {
    state.user.info.address2 = payload;
  },
  SET_USERZIPCODE(state, payload) {
    state.user.info.zipcode = payload;
  },
  SET_USERCITY(state, payload) {
    state.user.info.city = payload;
  },
  SET_USERREGION(state, payload) {
    state.user.info.region = payload;
  },
  SET_USERSTATE(state, payload) {
    state.user.info.state = payload;
  },
  SET_USERCOUNTRY(state, payload) {
    state.user.info.country = payload;
  },
  SET_USEREMAIL(state, payload) {
    state.user.info.email = payload;
  },
  SET_USERNUMBERPHONE(state, payload) {
    state.user.info.phone = payload;
  },
  SET_USERACCEPTED(state, payload) {
    state.user.info.accepted = payload;
  },
  SET_DATEOPTION(state, payload) {
    state.user.datetime.option = payload;
    state.user.datetime.rental = payload.rental;
    state.user.datetime.waiting = !payload.pickup;
    state.user.datetime.arrival = '';
    state.user.datetime.pickup = '';
  },
  SET_DATEDATE(state, payload) {
    state.user.datetime.date = payload;
    state.user.lists.timesArrival = [];
    state.user.lists.timesPickup = [];
    state.user.lists.optiondto = [];
    state.user.datetime.option = '';
    state.user.datetime.arrival = '';
    state.user.datetime.pickup = '';
    state.user.datetime.waiting = false;
    state.user.datetime.rental = false;
  },
  SET_DATETIMEARRIVAL(state, payload) {
    state.user.datetime.arrival = payload;
  },
  SET_DATETIMEPICKUP(state, payload) {
    state.user.datetime.pickup = payload;
  },
  SET_CONFIGLANGUAGE(state, payload) {
    state.user.config.language = payload.split('-')[0];
  },
  SET_CONFIGLANPROP(state, payload) {
    state.user.config.prop = payload;
  },
  SET_CONFIGCONTAINER(state, payload) {
    state.user.config.container = payload;
  },
  SET_CONFIGHOST(state, payload) {
    state.user.config.host = payload;
  },
  SET_CONFIGPARAMETERS(state, payload) {
    state.user.config.parameters = payload;
  },
  SET_TOKENPOLICY(state, payload) {
    state.user.tokenpolicy = payload;
    state.user.tokenexpirationtimer = payload.tokenexpirationvalue;
  },
  SET_TOKENTIMEOUT(state, payload) {
    state.user.tokenTimeout = setTimeout(() => {
      state.user.tokenexpired = true;
      const errorPayload = {
        modal: true,
        send: false,
        traceid: state.user.guid,
        error: {
          message: 'TOKEN_EXPIRED_' + state.user.tokenpolicy.tokenexpiration,
          jsondata: JSON.stringify(state.user.tokenpolicy)
        }
      };
      this.dispatch('errors/setDataTokenExpired', errorPayload);
    }, payload * 1000);
  },
  SET_LISTMAKES(state, payload) {
    state.user.lists.makes = payload.response;
  },
  SET_LISTSERVICES(state, payload) {
    if (payload.rooftopid !== undefined) {
      const departments = state.user.lists.departments.output;
      for (let i = 0; i < departments.length; i++) {
        if (departments[i].rooftopid === payload.rooftopid) {
          departments[i].services = payload.response;
        }
      }
    }

    state.user.lists.services = payload.response;
  },
  SET_LISTDEPARTMENTS(state, payload) {
    payload.forEach(item => {
      item['token'] = '';
      item['car'] = {
        makecode: '',
        modelcode: '',
        variantcode: ''
      };
      item['services'] = [];
    });
    state.user.lists.departments.output = payload;
  },
  SET_LISTSPECIFICDEPARTMENTS(state, payload) {
    state.user.lists.departments.initial = payload;
  },
  SET_LISTELIGABLEDEPARTMENTS(state, payload) {
    state.user.lists.departments.eligable = payload;
  },
  SET_LISTDATES(state, payload) {
    let local = [];
    payload.forEach(item => {
      local.push(item);
    });
    local.sort();
    state.user.lists.dates = local;
  },
  SET_LISTDATESCLEAR(state) {
    state.user.lists.dates = [];
  },
  SET_LISTRENTALDATES(state, payload) {
    let local = [];
    payload.forEach(item => {
      local.push(item);
    });
    local.sort();
    state.user.lists.rentaldates = local;
  },
  SET_LISTSELECTEDINDEXMAKE(state, payload) {
    state.user.lists.selectedIndexMake = payload;
  },
  SET_LISTSELECTEDINDEXMODEL(state, payload) {
    state.user.lists.selectedIndexModel = payload;
  },
  SET_LISTSELECTEDINDEXVARIANT(state, payload) {
    state.user.lists.selectedIndexVariant = payload;
  },
  SET_LISTOPTIONSMANUAL(state, payload) {
    state.user.lists.optiondtoManual = payload;
  },
  SET_LISTOPTIONS(state, payload) {
    state.user.lists.optiondto = payload;
  },
  SET_ERRORSAPP(state, payload) {
    state.user.errors.app = payload;
  },
  SET_ERRORSDATE(state) {
    let data = {
      endpoint: 'date',
      data: localizationTexts[state.user.config.language].errors.GetAvailableDatesError.title,
      error: localizationTexts[state.user.config.language].errors.GetAvailableDatesError.title
    };
    state.user.errors.date = data;
  },
  SET_ERRORSOPTIONS(state) {
    let data = {
      endpoint: 'options',
      data: localizationTexts[state.user.config.language].errors.GetAvailableTimesAndOptionsError.title,
      error: localizationTexts[state.user.config.language].errors.GetAvailableTimesAndOptionsError.title
    };
    state.user.errors.optiondto = data;
  },
  SET_ERRORS(state, payload) {
    switch (payload.endpoint) {
      case 'registration':
        state.user.errors.registration = payload.data;
        break;
      case 'departments':
        state.user.errors.departments = payload.data;
        break;
      case 'services':
        state.user.errors.services = payload.data;
        break;
      case 'date':
        state.user.errors.date = payload.data;
        break;
      case 'time':
        state.user.errors.time = payload.data;
        break;
      case 'customer':
        state.user.errors.customer = payload.data;
        break;
      case 'options':
        state.user.errors.optiondto = payload.data;
        break;
      default:
        state.user.errors.api = payload.data;
    }
    state.user.loading = false;
  },
  SET_VALIDATION(state, payload) {
    state.user.validation = payload;
  },
  SET_PICKUPTIMEOVERWRITE(state, payload) {
    //BWSOL2-508 til Andersen & Martini A/S
    state.user.specialProperties.pickuptimeOverwrite = payload;
  },
  SET_FORWARDINGENDPOINT(state, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    state.user.specialProperties.forwarding.endpoint = payload;
  },
  SET_MARKETINGCONSENT(state, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S
    state.user.specialProperties.forwarding.marketingConsent = payload;
  },
  SET_MARKETINGCONSENTTEXT(state, payload) {
    // BWSOL2-500 til Kia Import Danmark A/S

    if ((payload.indexOf('[') > -1) & (payload.indexOf(']') > -1)) {
      var s = payload;
      var matches = [];
      var pattern = /\[(.*?)\]/g;
      var match;
      while ((match = pattern.exec(s)) != null) {
        matches.push([...match]);
      }
      var i = 0;
      while (matches[i]) {
        // make link
        let link = matches[i][1];
        if (matches[i][1].indexOf('|') > -1) {
          let linkArray = matches[i][1].split('|');
          link = `<a href="${linkArray[1]}" target="_blank" @click.stop="" >${linkArray[0]}</a>`;
        }
        s = s.replace(matches[i][0], link);
        i++;
      }
      state.user.specialProperties.forwarding.marketingConsentText = s;
    } else {
      state.user.specialProperties.forwarding.marketingConsentText = payload;
    }
  },
  SEND_FORWARDINGBOOKINGINFO(state, payload) {
    state.user.dummy = payload;
    // BWSOL2-500 til Kia Import Danmark A/S
  },
  SET_REGISTRATIONPLATEERRORMESSAGE(state, payload) {
    state.user.registrationplateerrormessagekey = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
